import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TimeElapsePipe } from './time-elapse.pipe';

@NgModule({
  declarations: [TimeElapsePipe],
  imports: [CommonModule],
  exports: [TimeElapsePipe]
})
export class TimeElapseModule {}
